import { createContext } from 'react'

type Toast = {
  info: (msg: string) => void
  success: (msg: string) => void
  error: (msg: string) => void
}

const _toast: Toast = {
  info: () => {},
  success: () => {},
  error: () => {},
}

export const ToastContext = createContext({ toast: _toast })
